import * as React from 'react';
import { forwardRef, ReactElement, useImperativeHandle } from 'react';

import { Chip, Grid, Paper, Typography } from '@mui/material';
import { Vector3 } from '@react-three/fiber';

import { Scene } from '../ModelView/Scene';

export interface IItemCardProps {
    cameraPos?: [number, number, number];
    cameraTargetPos?: Vector3;
    canvasId: number;
    cardContent: string[];
    headerAvatar: ReactElement;
    headerLabel: string;
    maxZoomDistance?: number;
    models?: ReactElement[];
    orientation: "left" | "right";
    showMujocoGround?: boolean;
    modelRef?: any;
    minHeight?: number;
}

const ItemCard = forwardRef((props: IItemCardProps, ref) => {
    const { cameraPos, cameraTargetPos, canvasId, cardContent, headerAvatar, headerLabel, maxZoomDistance, models, orientation, showMujocoGround, modelRef, minHeight } = props;
    const id = `canvas-container-${canvasId}`;
    const textId = `paper-text-${canvasId}`;

    useImperativeHandle(ref, () => ({
        getContentMinHeight() {
            return document.getElementById(textId)?.clientHeight;
        }
    }));

    return(
        <Paper className="item-card-paper" elevation={24}>
            <Grid className="item-grid-container" container columns={2} direction="row">
                {(orientation === "left") ? (
                    <>
                        <Grid className="item-paper-content" item xs={1}>
                            <Grid id={textId} className="item-paper-content-grid item-paper-item-left" container direction="column">
                                <Grid className="item-paper-content-grid-header" item>
                                    <Chip color="error" icon={headerAvatar} label={headerLabel} />
                                </Grid>
                                <Grid className="item-paper-content-grid-body" item>
                                    {cardContent.map((content: string, index: number) => (
                                        <Typography className={index > 0 ? "item-paper-content-text-bullet-point" : ""} key={`typography-${content}-${index}`}>
                                            {content}
                                        </Typography>
                                    ))}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid className="item-paper-content" item xs={1}>
                            <div id={id} style={{ backgroundColor: "gray", overflow: "hidden", width: "calc(100% - 4vw)", marginLeft: "calc(2vw + 2px)", marginTop: "2vw", marginRight: "2vw", marginBottom: "2vw", height: minHeight}}>
                                {models && 
                                    <Scene cameraPos={cameraPos} cameraTargetPos={cameraTargetPos} maxZoomDistance={maxZoomDistance} models={models} showMujocoGround={showMujocoGround} modelRef={modelRef} />
                                }
                            </div>
                        </Grid>
                    </>
                ) : (
                    <>
                        <Grid className="item-paper-content" item xs={1}>
                            <div id={id} style={{ backgroundColor: "gray", overflow: "hidden", width: "calc(100% - 4vw)", marginLeft: "2vw", marginTop: "2vw", marginRight: "calc(2vw + 2px)", marginBottom: "2vw", height: minHeight}}>
                                {models && 
                                    <Scene cameraPos={cameraPos} cameraTargetPos={cameraTargetPos} maxZoomDistance={maxZoomDistance} models={models} showMujocoGround={showMujocoGround} modelRef={modelRef} />
                                }
                            </div>
                        </Grid>
                        <Grid className="item-paper-content" item xs={1}>
                            <Grid id={textId} className="item-paper-content-grid item-paper-item-right" container direction="column">
                                <Grid className="item-paper-content-grid-header" item>
                                    <Chip color="error" icon={headerAvatar} label={headerLabel} />
                                </Grid>
                                <Grid className="item-paper-content-grid-body" item>
                                    {cardContent.map((content: string, index: number) => (
                                        <Typography className={index > 0 ? "item-paper-content-text-bullet-point" : ""} key={`typography-${content}-${index}`}>
                                            {content}
                                        </Typography>
                                    ))}
                                </Grid>
                            </Grid>  
                        </Grid>
                    </>
                )}    
            </Grid>
            <div style={{height: "calc(100% - 4vh)", width: "5px", position: "absolute", left: "50%", top: "2vh", transform: "translateX(-50%)", borderRadius: "5px", backgroundColor: "#d32f2f", overflow: "hidden"}} />
        </Paper>
    );
})

export default ItemCard;